import styled from "styled-components";

import { breakpoints } from "Libs/theme";

export const SplitLayout = styled.div`
  flex-direction: column;
  display: flex;
  gap: 24px;

  @media (min-width: ${breakpoints[1]}) {
    #billing-address-form {
      display: grid;
      grid-column-gap: 32px;
      width: auto;
      grid-template-columns: 1fr 1fr !important;
    }
  }

  @media (min-width: ${breakpoints[2]}) {
    display: grid;
    grid-template-columns: 1fr 1.75fr;
    gap: 100px;
  }
`;

export const OverviewLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

export const Overview = styled.div`
  flex: 1;
  flex-grow: 0;
  background-color: var(
    --section-color-primary-100-background-color,
    var(--color-primary-100)
  );
  border-radius: var(
    --box-wrapper-section-border-radius,
    var(--section-8px-border-radius, var(--8px))
  );
  padding-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 24px;
`;

export const OverviewHr = styled.hr`
  border-top: 1px solid
    var(--section-periwinkle-grey-border-color, var(--periwinkle-grey));
`;

export const OverviewPrice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const OverviewTitle = styled.div`
  display: flex;
  flex-driction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 32px;

  @media (min-width: ${breakpoints[2]}) {
    #billing-address-form {
      div[class=""],
      div:not([class]) {
        display: none;
      }
    }

    #billing-address-form > .vat_number {
      grid-row: 1000;
      grid-column: 1 / 3;
    }
  }

  @media (min-width: ${breakpoints[3]}) {
    flex: 1.75;
  }
`;

export const Thanks = styled.div`
  flex: 1;
  background-color: var(
    --section-color-primary-100-background-color,
    var(--color-primary-100)
  );
  border-radius: var(
    --box-wrapper-section-border-radius,
    var(--section-8px-border-radius, var(--8px))
  );
  margin-top: 32px;
  margin-bottom: 32px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-grow: 0;
`;

export const PaymentMethods = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
